import { ReactNode } from 'react';
import { IEmptyStyle } from './IEmptyStyle';

const EmptyStyle = ({ emphasisedWords, emphasisedWordsColor, icon, text, children, textColor }: IEmptyStyle) => {
    const emphasise = (text: string, words: string[], color: string): string => {
        const escapedWords = words.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
        const regex = new RegExp(`(${escapedWords.join('|')})`, 'gi');
        return text.replace(regex, `<span style="font-weight: bold; color: ${color};">$1</span>`);
    }

    return (
        <div className='w-full h-full flex flex-col justify-center items-center'>
            <div className='flex justify-center items-center w-fit h-fit'>
                {icon}
            </div>
            <div className='text-[var(--primary-text-color)] text-[.9rem] mt-5 whitespace-nowrap' style={{ color: `${textColor}` }}
                dangerouslySetInnerHTML={{ __html: emphasise(text, emphasisedWords, emphasisedWordsColor) }}>
            </div>
            <div style={{ marginTop: '10px' }}>{children}</div>
        </div>
    )
}

export default EmptyStyle